import React from 'react'
import { compose, withHandlers, withState } from 'recompose'
import EyeOff from 'react-feather/dist/icons/eye-off'
import Eye from 'react-feather/dist/icons/eye'
import toFinalFormInput from '../FormElements/toFinalFormInput'
import { IconButton } from './styles'
import Input from '../Input/Input'

const PasswordInput = ({ showPassword, confirm, togglePassword, ...rest }) => {
  const Icon = showPassword ? EyeOff : Eye
  return (
    <Input
      {...rest}
      type={showPassword ? 'text' : 'password'}
      placeholder={confirm ? 'Re-enter password' : 'Enter password'}
      rightIcon={
        <IconButton type='button' onClick={togglePassword}>
          <Icon size={18} />
        </IconButton>
      }
    />
  )
}

const EnhancedPasswordInput = compose(
  withState('showPassword', 'setShowPassword', false),
  withHandlers({
    togglePassword: ({ showPassword, setShowPassword }) => event => {
      event.preventDefault()
      event.stopPropagation()
      setShowPassword(!showPassword)
    }
  })
)(PasswordInput)

export const FinalPasswordInput = toFinalFormInput(EnhancedPasswordInput)

export default EnhancedPasswordInput



// WEBPACK FOOTER //
// ./src/Components/PasswordInput/PasswordInput.jsx